import { Designation } from "@alba-cars/common-modules";

import IconFacebook from "@/components/Icons/IconFacebook";
import IconFacebookHover from "@/components/Icons/IconFacebookHover";
import IconInstagram from "@/components/Icons/IconInstagram";
import IconInstagramHover from "@/components/Icons/IconInstagramHover";
import IconLinkedin from "@/components/Icons/IconLinkedin";
import IconLinkedinHover from "@/components/Icons/IconLinkedinHover";
import IconTikTok from "@/components/Icons/IconTikTok";
import IconTikTokHover from "@/components/Icons/IconTikTokHover";
import IconTwitter from "@/components/Icons/IconTwitter";
import IconYouTube from "@/components/Icons/IconYouTube";
import albaHomesLogo from "@/public/assets/images/homes-logo.png";
import albaInnovationLogo from "@/public/assets/images/innovation-logo.png";
import albaJobsLogo from "@/public/assets/images/jobs-logo.png";
import RavoLogo from "@/public/assets/images/ravo-logo.png";

// social media

export const socialMediaHeroSectionIcons = [
  {
    default: IconFacebook,
    hover: IconFacebookHover,
    key: "facebook",
    url: "https://www.facebook.com/AlbaCarsDubai/",
    name: "Alba Cars Facebook",
  },
  {
    default: IconLinkedin,
    hover: IconLinkedinHover,
    key: "linkedin",
    url: "https://ae.linkedin.com/company/albacarsdubai",
    name: "Alba Cars Linkedin",
  },
  {
    default: IconInstagram,
    hover: IconInstagramHover,
    key: "instagram",
    url: "https://www.instagram.com/albacarsdxb/?hl=en",
    name: "Alba Cars Instagram",
  },
  {
    default: IconTikTok,
    hover: IconTikTokHover,
    key: "tiktok",
    url: "https://www.tiktok.com/@albacars?lang=en",
    name: "Alba Cars TikTok",
  },
];
export const socialMediaIcons = [
  {
    default: IconFacebook,
    hover: IconFacebookHover,
    key: "facebook",
    url: "https://www.facebook.com/AlbaCarsDubai/",
    name: "Alba Cars Facebook",
  },
  {
    default: IconLinkedin,
    hover: IconLinkedinHover,
    key: "linkedin",
    url: "https://ae.linkedin.com/company/albacarsdubai",
    name: "Alba Cars Linkedin",
  },
  {
    default: IconInstagram,
    hover: IconInstagramHover,
    key: "instagram",
    url: "https://www.instagram.com/albacarsdxb/?hl=en",
    name: "Alba Cars Instagram",
  },
  {
    default: IconTikTok,
    hover: IconTikTokHover,
    key: "tiktok",
    url: "https://www.tiktok.com/@albacars?lang=en",
    name: "Alba Cars TikTok",
  },
  {
    default: IconYouTube,
    hover: IconYouTube,
    key: "youtube",
    url: "https://www.youtube.com/@ALBACARSdxb",
    name: "Alba Cars YouTube",
  },
  {
    default: IconTwitter,
    hover: IconTwitter,
    key: "x",
    url: "https://x.com/albacarsdubai",
    name: "Alba Cars X",
  },
];
//  footer and navbar links
export type NavigationLink = {
  name: string;
  href: string;
  isFirstColumn?: boolean;
  isFourthColumn?: boolean;
  navBar?: boolean;
  noPrefetch?: boolean;
};

export const NavigationKeys = {
  HERO: "hero",
  NAV: "nav",
  FOOTER: "footer",
} as const;

export const navigationLinks: NavigationLink[] = [
  { name: "buy", href: "/buy-used-cars-uae", isFirstColumn: true, navBar: true },
  { name: "comingSoon", href: "/coming-soon", navBar: true },
  { name: "sell", href: "/sell-used-car-dubai", isFirstColumn: true, navBar: true },
  // { name: "212cars", href: "https://212.albacars.ae/", isFirstColumn: true, navBar: true },
  { name: "finance", href: "/used-car-finance", isFirstColumn: true, navBar: true },
  { name: "bankValuation", href: "/bank-valuation", isFirstColumn: true, navBar: true },
  { name: "ourTeam", href: "/our-team", isFirstColumn: true, navBar: true },
  { name: "aboutUs", href: "/about-us", isFirstColumn: true, navBar: true },
  { name: "latestNews", href: "/articles", isFirstColumn: true },
  { name: "contactUs", href: "/contact-us", isFirstColumn: true, navBar: true },
  { name: "privacyPolicy", href: "/privacy-policy", isFirstColumn: true },
  { name: "termsAndConditions", href: "/terms-and-conditions", isFirstColumn: true },
  { name: "careers", href: "https://careers.albacars.ae/", isFirstColumn: true },

  // Fourth column links
  { name: "usedCarsInDubai", href: "/buy-used-cars-uae", isFourthColumn: true },
  { name: "dubaiCar", href: "/buy-used-cars-uae", isFourthColumn: true },
  { name: "dubaiUsedCars", href: "/buy-used-cars-uae", isFourthColumn: true },
  { name: "sellTheCarInDubai", href: "/sell-used-car-dubai", isFourthColumn: true },
  { name: "carSalesInDubai", href: "/sell-used-car-dubai", isFourthColumn: true },
  { name: "carBuyersDubai", href: "/sell-used-car-dubai", isFourthColumn: true },
  { name: "buyUsedCarsOnInstallment", href: "/buy-used-cars-uae", isFourthColumn: true },
  { name: "secondHandCarsNearMe", href: "/buy-used-cars-uae", isFourthColumn: true },
  { name: "howToSellCar", href: "/article/step-by-step-guide-to-selling-your-car-in-dubai", isFourthColumn: true },
  { name: "zeroDownPayment", href: "/buy-used-cars-uae", isFourthColumn: true },
  { name: "bestDealers", href: "/buy-used-cars-uae", isFourthColumn: true },
];

export const mobileNavigationLinks: NavigationLink[] = [
  { name: "home", href: "/", navBar: true },
  { name: "buy", href: "/buy-used-cars-uae", navBar: true },
  { name: "comingSoon", href: "/coming-soon", navBar: true },
  { name: "sell", href: "/sell-used-car-dubai", navBar: true },
  // { name: "212cars", href: "https://212.albacars.ae/", navBar: true },
  { name: "finance", href: "/used-car-finance", navBar: true },
  { name: "bankValuation", href: "/bank-valuation", navBar: true },
  { name: "ourTeam", href: "/our-team", navBar: true },
  { name: "aboutUs", href: "/about-us", navBar: true },
  { name: "latestNews", href: "/articles", navBar: true },
  { name: "contactUs", href: "/contact-us", navBar: true },
  { name: "clientPortal", href: "/my-profile", navBar: true, noPrefetch: true },
  { name: "myFavorites", href: `/favorites?source=${NavigationKeys.NAV}`, navBar: true, noPrefetch: true },
];
// footer logos
export const footerLogos = [
  {
    src: albaHomesLogo,
    alt: "alba homes",
    width: 150,
    height: 60,
    link: "https://alba.homes",
    sizes: "(max-width: 640px) 80px, (max-width: 1024px) 120px, 150px",
  },
  {
    src: albaJobsLogo,
    alt: "albs jobs",
    width: 150,
    height: 60,
    link: "https://www.alba.jobs/",
    sizes: "(max-width: 640px) 80px, (max-width: 1024px) 120px, 150px",
  },
  {
    src: RavoLogo,
    alt: "ravo",
    width: 150,
    height: 60,
    link: "https://ravo.app/",
    sizes: "(max-width: 640px) 80px, (max-width: 1024px) 120px, 150px",
  },
  {
    src: albaInnovationLogo,
    alt: "alba innovation",
    width: 150,
    height: 60,
    link: "https://alba.business/",
    sizes: "(max-width: 640px) 80px, (max-width: 1024px) 120px, 150px",
  },
];

// why alba steps
export const whyAlbaItems = [
  {
    src: "/assets/images/why-alba-rep.png",
    alt: "Easy Financing",
    label: "Easy Financing",
  },
  {
    src: "/assets/images/why-albacars-second.png",
    alt: "Certified used cars",
    label: "Certified used cars",
  },
  {
    src: "/assets/images/why-albacars-third.png",
    alt: "Happy Customers",
    label: "Happy Customers",
  },
];

// Blurred logos
export const blurredAlbaCarsLogoDataUrl =
  "data:image/jpeg;base64,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";

// phone number
export const phoneNumber = "+97143772503";

// footer make links config
export const footerMakeLinks = [
  { name: "Audi", id: 3, slug: "audi", translation: { ar: "أودي" } },
  { name: "BMW", id: 8, slug: "bmw", translation: { ar: "بي ام دبليو" } },
  { name: "Cadillac", id: 11, slug: "cadillac", translation: { ar: "كاديلاك" } },
  { name: "Chevrolet", id: 18, slug: "chevrolet", translation: { ar: "شيفروليه" } },
  { name: "Dodge", id: 21, slug: "dodge", translation: { ar: "دوج" } },
  { name: "Ford", id: 30, slug: "ford", translation: { ar: "فورد" } },
  { name: "GMC", id: 31, slug: "gmc", translation: { ar: "جي ام سي" } },
  { name: "Honda", id: 37, slug: "honda", translation: { ar: "هوندا" } },
  { name: "Infiniti", id: 40, slug: "infiniti", translation: { ar: "إنفينيتي" } },
  { name: "Jaguar", id: 42, slug: "jaguar", translation: { ar: "جاكوار" } },
  { name: "Jeep", id: 44, slug: "jeep", translation: { ar: "جيب" } },
  { name: "Land Rover", id: 63, slug: "land-rover", translation: { ar: "لاند روفر" } },
  { name: "Maserati", id: 57, slug: "maserati", translation: { ar: "ماسراتي" } },
  { name: "Mercedes-Benz", id: 60, slug: "mercedes-benz", translation: { ar: "مرسيدس بنز" } },
  { name: "Nissan", id: 64, slug: "nissan", translation: { ar: "نيسان" } },
  { name: "Porsche", id: 72, slug: "porsche", translation: { ar: "بورش" } },
  { name: "Range Rover", id: 104, slug: "range-rover", translation: { ar: "رانج روفر" } },
  { name: "Rolls Royce", id: 122, slug: "rolls-royce", translation: { ar: "رولز رویس" } },
  { name: "Subaru", id: 87, slug: "subaru", translation: { ar: "سوبارو" } },
  { name: "Tesla", id: 121, slug: "tesla", translation: { ar: "تيسلا" } },
  { name: "Volkswagen", id: 103, slug: "volkswagen", translation: { ar: "فولكس واغن" } },
  { name: "Volvo", id: 88, slug: "volvo", translation: { ar: "فولفو" } },
];

export const footerMakeMap = {
  "3": "audi",
  "8": "bmw",
  "11": "cadillac",
  "18": "chevrolet",
  "21": "dodge",
  "30": "ford",
  "31": "gmc",
  "37": "honda",
  "40": "infiniti",
  "42": "jaguar",
  "44": "jeep",
  "57": "maserati",
  "60": "mercedes-benz",
  "63": "land-rover",
  "64": "nissan",
  "72": "porsche",
  "87": "subaru",
  "88": "volvo",
  "103": "volkswagen",
  "104": "range-rover",
  "121": "tesla",
  "122": "rolls-royce",
};

export type FooterMakeLink = (typeof footerMakeLinks)[number];

export const bodyTypes = [
  { name: "Sedan", value: "sedan" },
  { name: "SUV", value: "suv" },
  { name: "Coupe", value: "coupe" },
  { name: "Hatchback", value: "hatchback" },
  { name: "Wagon", value: "wagon" },
  { name: "Convertible", value: "convertible" },
  { name: "Van", value: "van" },
  { name: "Pickup", value: "pickup" },
];
export const dubaiReview = "https://www.dubaireview.ae/listing/alba-cars/#reviews";

export const REGISTER_ERRORS = {
  USER_ALREADY_EXISTS: 1,
  VALIDATION_ERROR: 2,
  INTERNAL_SERVER_ERROR: 3,
} as const;

export const AUTH_ERRORS = {
  REFRESH_TOKEN_EXPIRED: "RefreshAccessTokenError",
} as const;

export const QUERY_KEYS = {
  USER_PROFILE: "user-profile",
} as const;

export const MAX_ALLOWED_FILE_SIZE_MB = 5;
export const MAX_ALLOWED_DOC_SIZE_MB = 10;

// 32x23 blurred car-in-showroom photo; the browser scales and blurs it, so a few pixels are enough.
export const DEFAULT_PLACEHOLDER = `data:image/webp;base64,UklGRuoAAABXRUJQVlA4IN4AAAAwBgCdASogABcAPm0uk0akIqGhMBgIAIANiWMAnTOPRqZgAfv9MJMWqG5yF5s0AWsma5uXghXlwzwAAP7tDzKar3AtG8Mn34x/RFTGBsSr9RfPRZ7C8TG2k5ACKCJ18HE2AQhlM4xOz55NsxIgqvTd8subuaQGdJehOA9I1aXHCGJTUOeiczSS/+neah9WxfygcqBEMaYZUGTRmEqug3smNSsb+45bclMA/saKQaqMifpA0lBKqw5IfCzcf+RNBo+hZmkk1+QT8jXSwNV5DRxr18ypAJ8bKQDa8/FIAAA=`;

export type HeadingTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

export const LOCAL_STORAGE_KEYS = {
  pendingValuationRequestId: "pendingValuationRequestId",
} as const;

export const FREE_VALUATION_REQUEST_TYPE = "Free Valuation";

export const MARKETING_KEYS = {
  FreeValuation: "car_value",
};

export const TWITTER_PIXEL_ID = "oc2l3";

/** X conversion event suffixes — full ID format: tw-{TWITTER_PIXEL_ID}-{suffix} */
export const TWITTER_CONVERSION_EVENTS = {
  testDrive: "rda87",
  sellCar: "rf2lu",
} as const;

export type TwitterConversionEvent = keyof typeof TWITTER_CONVERSION_EVENTS;

/** OpenAI Ads pixel ID — override with NEXT_PUBLIC_OPENAI_PIXEL_ID */
export const OPENAI_PIXEL_ID = "TPuwMDzeCx2wsUjTMv6Dcq";

/**
 * UTM sources captured under MarketingData.OpenAI.
 * Update this list if marketing changes the source naming.
 */
export const OPENAI_UTM_SOURCES = ["openai"] as const;

export const CONTAINER_IDS = {
  bankValuation: "bank-valuation-form",
  bankValuationPayLater: "bank-valuation-pay-later",
  testDriveFormSuccessMessage: "test-drive-form-success-message",
};

export const BLOG_AUTHOR = "Myo Satt";

export const DESIGNATION_TRANSLATIONS: Record<Designation, any> = {
  [Designation.SALES_MANAGER]: {
    ar: "مدير مبيعات",
  },
  [Designation.SALES_EXECUTIVE]: {
    ar: "مندوب مبيعات",
  },
  [Designation.CO_FOUNDER]: {
    ar: "مؤسس مشارك",
  },
  [Designation.CHIEF_SALES_OFFICER]: {
    ar: "رئيس المبيعات التنفيذي",
  },
  [Designation.CHIEF_PURCHASING_OFFICER]: {
    ar: "رئيس المشتريات التنفيذي",
  },
  [Designation.PURCHASE_MANAGER]: {
    ar: "مدير مشتريات",
  },
  [Designation.PURCHASER]: {
    ar: "مندوب مشتريات",
  },
  [Designation.FINANCE_MANAGER]: {
    ar: "المدير المالي",
  },
  [Designation.HEAD_OF_ACCOUNTS]: {
    ar: "رئيس قسم الحسابات",
  },
  [Designation.CHIEF_MARKETING_OFFICER]: {
    ar: "رئيس التسويق التنفيذي",
  },
  [Designation.MARKETING_MANAGER]: {
    ar: "مدير التسويق",
  },
  [Designation.AFTERCARE_DIRECTOR]: {
    ar: "مدير خدمات بعد البيع",
  },
  [Designation.AFTERCARE]: {
    ar: "موظف خدمات بعد البيع",
  },
  [Designation.DIRECTOR_OF_TECHNOLOGY]: {
    ar: "رئيس قسم التكنولوجيا",
  },
  [Designation.PURCHASE_EXECUTIVE]: {
    ar: "مندوب مشتريات",
  },
  [Designation.RELATIONSHIP_MANAGER]: {
    ar: "مدير العلاقات",
  },
  [Designation.SALES_CONTROLLER]: {
    ar: "مراقب مبيعات",
  },
  [Designation.LOGISTICS_MANAGER]: {
    ar: "مدير لوجستيات",
  },
  [Designation.SALES_COORDINATOR]: {
    ar: "منسق مبيعات",
  },
  [Designation.MARKETING_OPERATIONS_MANAGER]: {
    ar: "مدير عمليات التسويق",
  },
  [Designation.TEAM_LEADER]: {
    ar: "قائد فريق",
  },
  [Designation.CALL_CENTER_MANAGER]: {
    ar: "مدير مركز الاتصالات",
  },
  [Designation.BUSINESS_OPERATIONS_MANAGER]: {
    ar: "مدير عمليات العمليات التجارية",
  },
  [Designation.BUSINESS_RELATIONSHIP_MANAGER]: {
    ar: "مدير العلاقات التجارية",
  },
  [Designation.SENIOR_PURCHASE_EXECUTIVE]: {
    ar: "كبير مسؤولي المشتريات",
  },
  [Designation.F_I_TEAM_LEADER]: {
    ar: "قائد فريق التمويل والتأمين",
  },
  [Designation.F_I_COORDINATOR]: {
    ar: "منسق التمويل والتأمين",
  },
  [Designation.HANDOVER_FINANCE_SPECIALIST]: {
    ar: "أخصائي التسليم والتمويل",
  },
  [Designation.FINANCE_INSURANCE_COORDINATOR]: {
    ar: "منسق التمويل والتأمين",
  },
  [Designation.FINANCE_INSURANCE_TEAM_LEADER]: {
    ar: "قائد فريق التمويل والتأمين",
  },
  [Designation.CUSTOMER_CARE_SPECIALIST]: {
    ar: "أخصائي خدمة العملاء",
  },
  [Designation.AFTER_SALES_COORDINATOR]: {
    ar: "منسق ما بعد البيع",
  },
  [Designation.ACCOUNT_MANAGER]: {
    ar: "مدير حسابات",
  },
  [Designation.MANAGER]: {
    ar: "المدير",
  },
  [Designation.SUPERVISOR]: {
    ar: "المشرف",
  },
  [Designation.ASSOCIATE]: {
    ar: "مساعد",
  },
  [Designation.INTERN]: {
    ar: "متدرب",
  },
  [Designation.FINANCE_INSURANCE_AGENT]: {
    ar: "وكيل تمويل وتأمين",
  },
  [Designation.FI_AGENT]: {
    ar: "وكيل تمويل وتأمين",
  },
  [Designation.PURCHASE_TEAM_LEADER]: {
    ar: "قائد فريق مشتريات",
  },
  [Designation.SALES_TEAM_LEADER]: {
    ar: "قائد فريق مبيعات",
  },
};

export const ALBA_CARS_SHOWROOM_MAPS_URL = "https://maps.app.goo.gl/4j3s2MyFDHHJqCfb6";
export const ALBA_CARS_SHOWROOM_ADDRESS = "Alba Cars Showroom, Dubai, UAE";

export const FEATURED_STOCK_AGE_DAYS = 90 as const;

/** Flip to `true` to restore the showroom location filter in the buy-page header. */
export const SHOW_SHOWROOM_LOCATION_FILTER = false;
